module.exports = __webpack_public_path__ + "img/img5.1ad1e2ad.jpg";